module.exports = __webpack_public_path__ + "static/media/img4.ba6d9f7a.jpg";